

exports.__esModule = true;

require('components/xo-wallet-components/src/add-bank/route');

require('components/xo-wallet-components/src/add-card/route');

require('components/xo-member-components/src/select-shipping/add-shipping/route');

require('components/xo-member-components/src/select-shipping/delete-shipping/route');

require('components/xo-member-components/src/select-shipping/update-shipping/route');

require('pages/xo-shipping/route');

require('./directive');

require('pages/xo-sidebar-add-shipping/route');

require('pages/xo-sidebar-update-shipping/route');

require('pages/xo-sidebar-add-card/route');

require('pages/xo-sidebar-add-bank/route');

require('pages/xo-sidebar-currency-conversion/route');

require('pages/xo-sidebar-installment-options/route');

require('pages/xo-wallet/route');

var _route = require('pages/xo-sidebar-manage-wallet/route');

var _route2 = _interopRequireDefault(_route);

var _route3 = require('pages/xo-sidebar-update-card/route');

var _route4 = _interopRequireDefault(_route3);

var _index = require('squid/index');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _index.$Route.extend('$SidebarRoute', {

    path: 'sidebar',
    directive: 'xo-sidebar',
    children: [{
        name: '$SidebarShippingRoute',
        attributes: {
            token: 'props.token'
        }
    }, {
        name: '$SidebarAddShippingRoute',
        attributes: {
            token: 'props.token'
        }
    }, {
        name: '$SidebarAddCardRoute',
        attributes: {
            token: 'props.token',
            promotion: 'props.promotion'
        }
    }, {
        name: '$SidebarAddBankRoute',
        attributes: {
            token: 'props.token'
        }
    }, {
        name: '$SidebarWalletRoute',
        props: function props() {
            return {
                token: this.props.token,
                promotion: this.props.promotion,
                installment: this.props.installment
            };
        },
        config: function config() {
            return {
                heading: 'asideHeader.fundingInstruments',
                subHeading: 'asideHeader.fundingInstrumentsSubHead',
                addRoute: 'checkout.review.sidebar.sidebarAddCard.addCardFlow.addCard'
            };
        }
    }, {
        name: '$AddBankFlowRoute',
        attributes: {
            token: 'props.token',
            'parent-callbacks': 'callbacks'
        }
    }, {
        name: '$AddCardPageRoute',
        attributes: {
            token: 'props.token',
            'parent-callbacks': 'callbacks'
        }
    }, {
        name: '$AddShippingRoute',
        attributes: {
            token: 'props.token',
            'parent-callbacks': 'callbacks',
            'done-fn': 'callbacks.done',
            sidebar: 'sidebar',
            update: 'props.update'
        }
    }, {
        name: '$UpdateShippingRoute',
        attributes: {
            token: 'props.token',
            'parent-callbacks': 'callbacks',
            'done-fn': 'callbacks.done',
            sidebar: 'sidebar'
        }
    }, {
        name: '$DeleteShippingRoute',
        attributes: {
            token: 'props.token',
            'parent-callbacks': 'callbacks',
            sidebar: 'sidebar'
        }
    }, {
        name: '$SidebarCurrencyConversionRoute',
        attributes: {
            token: 'props.token'
        }
    }, {
        name: '$SidebarInstallmentOptionsRoute',
        attributes: {
            token: 'props.token'
        }
    }, {
        route: _route2['default'],
        props: function props() {
            return {
                token: this.token
            };
        }
    }, {
        route: _route4['default'],
        props: function props() {
            return {
                token: this.token
            };
        }
    }]
});


_index.$Route;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./pages/xo-sidebar/route.js
// module id = ./pages/xo-sidebar/route.js
// module chunks = 1